module.exports = __webpack_public_path__ + "static/media/Kubota.8196f713.jpeg";